export class InvestorProductPlanIdentifiersApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getIdentifiers() {
    return this.#http.get('/api/investor-product-plan-identifiers');
  }
}
